import React from "react";
import notify from "../../assets/notify.svg";

function NotifcationModal() {
  const notifications = [
    {
      id: 1,

      message: "Your payment has been made successfully",
      time: "2:00pm",
    },
    {
      id: 2,

      message: "Your payment has been made successfully",
      time: "2:00pm",
    },
  ];

  return (
    <div className="">
      <div className="flex items-center gap-2 pb-2  ">
        <img src={notify} alt="" />
        <h6>new ({notifications.length})</h6>
      </div>
      <hr className="w-[102px] h-4 mb-[38px] " />
      <div className="flex flex-col gap-[24px] ">
        {notifications.map((notification) => (
          <div className="flex flex-col gap-2 pb-2  ">
            <h6 className="text-base">{notification.message}</h6>
            <h6 className="text-sm">{notification.time}</h6>
          </div>
        ))}
      </div>
    </div>
  );
}

export default NotifcationModal;
